import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function getCompanyProject() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllProductByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getMyProject(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyProducts${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSharedProject() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedProducts`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getProjectList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllProductByReportingUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getProductDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByDealProductId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteDealProduct(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteDealProduct/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createDealProduct(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createDealProduct`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateDealProduct(payload, drawerId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateDealProduct/${drawerId}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createDealProduct,
    deleteDealProduct,
    updateDealProduct,
    getMyProject,
    getCompanyProject,
    getSharedProject,
    getProjectList,
    getProductDetails,
}